import typeToReducer from 'type-to-reducer';
import update from 'immutability-helper';
import _findIndex from 'lodash/findIndex';
import _each from 'lodash/each';
import _size from 'lodash/size';
import {USER_LOGOUT, USER_SIGNIN, BRANDS_DATA, TOGGLE_PROLONG_SESSION_MODAL, UPDATE_USER_BALANCE, COUNT_SMS_REQUEST_SESSION_EXTENSION, SEND_SMS_PROLONG_SESSION, UPDATE_PROLONG_SESSION} from 'authActions.js';

let initialState = {
    isPending: false,
    isLogged: false,
    error: null,
    user: null,
    brandData: null,
    isOpenProlongSessionModalObject: {isOpen: false, sessionClosed: false},
    smsRequestSessionExtensionCounter: 0
};

export default typeToReducer({
    [USER_LOGOUT]: (state, action) => {
        return {...state, isLogged: false, user: null, isOpenProlongSessionModalObject: {isOpen: false, sessionClosed: false}, smsRequestSessionExtensionCounter: 0}
    },

    [USER_SIGNIN]: {
        PENDING: (state, action) => {
            return {...state, isPending: true}
        },
        FAILURE: (state, {payload: {error}}) => {
            return {...state, isPending: false, error};
        },
        SUCCESS: (state, {payload: {user}}) => {
            return {...state, isLogged: true, isPending: false, user};
        }
    },

    [BRANDS_DATA] : {
        PENDING: (state, action) => {
            return {...state, isPending: true}
        },
        FAILURE: (state, {payload: {error}}) => {
            return {...state, isPending: false, error};
        },
        SUCCESS: (state, {payload: {brandData}}) => {
            return {...state, isPending: false, brandData};
        }
    },

    [TOGGLE_PROLONG_SESSION_MODAL]: (state, {payload: {isOpenProlongSessionModalObject}}) => {
        return {...state, isOpenProlongSessionModalObject};
    },

    [UPDATE_USER_BALANCE]: (state, {payload:{data:{newBalance, bonusBalanceList = [], creditBonusBalance}}}) => {
        let user = update(state.user, {balance: {$set: newBalance}});

        if (_size(bonusBalanceList) && ('bonusBalanceList' in user) && _size(user['bonusBalanceList'])) {
            _each(bonusBalanceList, ({wagerBonusId, amount}) => {
                wagerBonusId = Number(wagerBonusId);
                const indexOfItem = _findIndex(user.bonusBalanceList, {wagerBonusId});
                if (indexOfItem != -1) {
                    user = update(user, {bonusBalanceList: {[indexOfItem]: {amount: {$set: amount}}}})
                }
            });

        }

        if(creditBonusBalance){
          user = update(user, {creditBonusBalance: {$set: creditBonusBalance}});
        }
        return {...state, user}
    },

    [COUNT_SMS_REQUEST_SESSION_EXTENSION]: (state, {payload: {smsRequestSessionExtensionCounter}}) => {
        return {...state, smsRequestSessionExtensionCounter};
    },

    [SEND_SMS_PROLONG_SESSION]: {
        PENDING: (state, action) => {
            return {...state, isPending: true, error: null}
        },
        FAILURE: (state, {payload: {error}}) => {
            return {...state, isPending: false, error};
        },
    },

    [UPDATE_PROLONG_SESSION]: (state, {payload:{data}}) => {
        let user = update(state.user, {prolongSession: {$set: data}});

        return {...state, user};
    }

}, initialState)